var map = {
	"./android.png": "d8cb",
	"./android2.png": "89e3",
	"./beidou.png": "8c1b",
	"./hdmi.png": "2e41",
	"./pda.png": "418e",
	"./qq.png": "4d88",
	"./sogou.png": "0068",
	"./speedtest.png": "1ba1",
	"./weixin.png": "21e3",
	"./下载.jpg": "1977"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "66ea";